import { getCookieByName } from '~/utilities/data/getCookieByName';

/**
 * Reads the 'eupubconsent' publisher consent cookie.
 *
 * This function checks if the `__tcfapi` function is available in the window object.
 * If `__tcfapi` is not available, it retrieves the value of the 'eupubconsent' cookie.
 * If `__tcfapi` is available, it returns an empty string.
 *
 * @returns {string} - The value of the 'eupubconsent' cookie or an empty string if `__tcfapi` is available.
 */
export function readPublisherConsentCookie(): string {
  if (!window.__tcfapi) {
    return getCookieByName('eupubconsent');
  }
  return '';
}
